import React from "react";

const MiniChart = ({ prices = [], trend }) => {

  if (prices.length < 2) {
    return (
      <svg
        width="120"
        height="45"
        viewBox="0 0 140 40"
      />
    );
  }

  const min = Math.min(...prices);
  const max = Math.max(...prices);

  const range = max - min || 1;

  const points = prices.map((price, index) => {

    const x = (index / (prices.length - 1)) * 140;

    const y = 35 - ((price - min) / range) * 30;

    return `${x},${y}`;

  });

  const line = points.join(" ");

  const area = `${line} 140,40 0,40`;

  return (

    <svg
      width="120"
      height="45"
      viewBox="0 0 140 40"
      preserveAspectRatio="none"
    >

      <polyline
        points={area}
        fill={
          trend === "up"
            ? "rgba(0,210,106,.10)"
            : "rgba(255,59,48,.10)"
        }
        stroke="none"
      />

      <polyline
        points={line}
        fill="none"
        stroke={
          trend === "up"
            ? "#00d26a"
            : "#ff3b30"
        }
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

    </svg>

  );

};

export default MiniChart;